export default __webpack_public_path__ + "static/hipopener_2-fa56f04e5ff8f51ed265113ecbfc45a9.jpg";